/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CaoZuoRiZhiChaXunTiaoJian,
  ResponseApiIPageGuangGaoZhuCaoZuoRiZhiDTO,
  ResponseApiIPageYunYingCaoZuoRiZhiDTO,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class CaoZuoRiZhiGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags CaoZuoRiZhiGuanLi
   * @name PageAdvertiserLogsUsingPost
   * @summary 分页查询广告主操作日志
   * @request POST:/dsp-admin/api/operation-logs/advertiser/page
   * @secure
   */
  pageAdvertiserLogsUsingPost = (
    queryDTO: CaoZuoRiZhiChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageGuangGaoZhuCaoZuoRiZhiDTO, void>({
      path: `/dsp-admin/api/operation-logs/advertiser/page`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CaoZuoRiZhiGuanLi
   * @name PageOperatorLogsUsingPost
   * @summary 分页查询运营操作日志
   * @request POST:/dsp-admin/api/operation-logs/operator/page
   * @secure
   */
  pageOperatorLogsUsingPost = (
    queryDTO: CaoZuoRiZhiChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageYunYingCaoZuoRiZhiDTO, void>({
      path: `/dsp-admin/api/operation-logs/operator/page`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new CaoZuoRiZhiGuanLi();
